/* External dependencies */
import { filter, Observable, switchMap } from 'rxjs';

/* Local dependencies */
import { setAuthenticatedClient } from '../../../../client/graphql';
import {
  UpdateDeviceActions,
  UpdateDeviceActionTypes,
  updateDeviceFailed,
  UpdateDeviceRequest,
  updateDeviceSucceeded,
} from './action';
import { updateDeviceQuery } from './updateDeviceQuery';

export function updateDeviceEpic(action$): Observable<UpdateDeviceActionTypes> {
  return action$.pipe(
    filter((action: UpdateDeviceActions) => action.type === UpdateDeviceActionTypes.UPDATE_DEVICE_REQUEST),
    switchMap((action: UpdateDeviceRequest) =>
      updateDevice(action.input).then(updateDeviceSucceeded).catch(updateDeviceFailed),
    ),
  );
}

export async function updateDevice(input) {
  const graphQLClient = await setAuthenticatedClient();
  try {
    const {
      data: { updateDevice: updatedDevice },
    } = await graphQLClient.mutate({
      mutation: updateDeviceQuery,
      variables: { input },

      update: (cache, { data: mutationData }) => {
        if (!mutationData?.updateDevice) return;

        const updatedDevice = mutationData.updateDevice;

        // Найти устройство в кэше по ID
        const deviceId = cache.identify({
          __typename: 'Terminal',
          id: updatedDevice.id,
        });

        cache.modify({
          id: deviceId,
          fields: {
            organization: () => updatedDevice.organization,
            notes: () => updatedDevice.notes,
          },
        });
      },
    });

    return updatedDevice;
  } catch (error) {
    throw new Error('Failed to get device');
  }
}
